/* eslint-disable react/no-danger */
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

// Utils:
import TopicConfigContext from 'utilities/topicConfigContext';

// Style:
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { createMarkup } from 'utilities/utils';
import muiTheme from '../../theme';

// Components:
import OptionsPopup from '../UI/OptionsPopup';

const styles = {
    '&.MuiGrid-root': {
        padding: '0.6rem 0 1.5rem 0',
        flexWrap: 'wrap',
    },
    '&.MuiButton-root': {
        borderRight: '1px solid rgb(99, 167, 220) !important',
        minHeight: 'fit-content',
        margin: '0.5em 0',
        width: 'fit-content',
    },
    '&.MuiIconButton-root': {
        margin: 0,
    },
    '&.MuiButtonGroup-root': {
        margin: '0.7rem',
        minWidth: '45%',
        maxWidth: '85%',
    },
    '&.MuiButton-contained': {
        background: muiTheme.palette.secondary.dark,
        color: 'white',
        '&:hover': {
            background: muiTheme.palette.secondary.light,
        },
    },
    '&.MuiButton-outlined': {
        color: muiTheme.palette.darkGray.main,
        '&:hover': {
            background: muiTheme.palette.lightGray.main,
        },
    },
    '&.MuiTypography-subtitle1': {
        marginLeft: '0.5rem',
    },
};

const ButtonSwitch = ({
    theme,
    tab,
    ncdmContent,
    ncdmSelections,
    topicNcdms,
}) => {
    // // Context // //
    const topicConfigContext = useContext(TopicConfigContext);

    // Check to omit the buttons when on the NCDM More Data theme
    const isDisplayed = theme !== 'moredata';

    return (
        <>
            <Grid
                item
                container
                direction="row"
                justifyContent="space-between"
                sx={styles}
            >
                {isDisplayed ? (
                    <ButtonGroup
                        size="medium"
                        aria-label="small outlined button group"
                        sx={styles}
                    >
                        <div className="button-group-wrap-container">
                            {' '}
                            {topicConfigContext.theme.tabs.map((themeTab) => (
                                <Button
                                    className="button-group-button"
                                    key={themeTab.tabPath}
                                    component={Link}
                                    to={`/${topicConfigContext.topic.topicUrlPath}/${topicConfigContext.theme.themePath}/${themeTab.tabPath}`}
                                    variant={
                                        tab === themeTab.tabPath
                                            ? 'contained'
                                            : 'outlined'
                                    }
                                    sx={styles}
                                >
                                    <span
                                        // In place to utilize css 'hyphens: manual' rule for longer button titles that overflow on mobile.
                                        dangerouslySetInnerHTML={createMarkup(
                                            themeTab.tabTitle
                                        )}
                                    ></span>
                                </Button>
                            ))}
                        </div>
                    </ButtonGroup>
                ) : (
                    // If not displaying buttons we render the NCDM header text
                    <Typography variant="subtitle1" sx={styles}>
                        <Box fontWeight="fontWeightBold">
                            {topicConfigContext.tab?.ncdmSettings?.textHeader}
                        </Box>
                    </Typography>
                )}
                <div className="options-popup">
                    <OptionsPopup
                        ncdmContent={ncdmContent}
                        ncdmSelections={ncdmSelections}
                        topicNcdms={topicNcdms}
                    ></OptionsPopup>
                </div>
            </Grid>
            <div className="main-content-title-container">
                {topicConfigContext.tab?.mapSettings?.contentTitle ? (
                    <Typography variant="h6" component="h1">
                        {topicConfigContext.tab.mapSettings.contentTitle}
                    </Typography>
                ) : null}

                {topicConfigContext.tab?.mapSettings?.contentSubtitle ? (
                    <Typography variant="subtitle2" component="h2">
                        {topicConfigContext.tab.mapSettings.contentSubtitle}
                    </Typography>
                ) : null}
            </div>
        </>
    );
};

export default ButtonSwitch;
